// AIDEV-SECURITY: Decide se falha do /auth/refresh e rejeicao de credencial (desloga)
// ou falha transitoria de rede/servidor (mantem sessao). Errar aqui = incidente de
// perda de carrinho (2026-08: oscilacao de rede deslogou vendedor e apagou pedido de R$38k).
export function isAuthRejection(err: unknown): boolean {
  const status = (err as { response?: { status?: number } })?.response?.status;
  return status === 401 || status === 403;
}
